import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {
  PollResult,
  ToolExecuteParams,
  ToolResult,
} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {poll} from 'common/src/modules/shared/copilot/utils/poll';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {CreativeTemplatesManagerAgentToolName} from '../creativeTemplatesManagetAgent.enums';

const inputSchema = z.object({});

function navigateToCreativeTemplatesLibraryTool(store: CLStore) {
  function _isCreativeTemplatesLibraryDataReady(): PollResult {
    if (
      store.getState().application.breadcrumbs.includes(BreadcrumbName.CreativeTemplatesLibrary) &&
      store.getState().creativeTemplatesLibrary.templates.length
    ) {
      return {passed: true};
    }

    return {passed: false, reason: 'Creative templates library failed to load'};
  }

  async function execute({}: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    routingService.goTo({
      url: Routes.CreativeTemplatesLibrary,
    });

    const result = await poll({checkFn: _isCreativeTemplatesLibraryDataReady});

    return toolResult(result.passed ? `Navigated to creative templates library` : result.reason);
  }

  return tool({
    name: CreativeTemplatesManagerAgentToolName.NavigateToCreativeTemplatesLibrary,
    description: 'Navigate to creative templates library',
    displayName: 'Navigating',
    execute,
    inputSchema,
  });
}

export default navigateToCreativeTemplatesLibraryTool;
